import(/* webpackMode: "eager" */ "/codebuild/output/src2103436129/src/apps/wrap.gifts/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2103436129/src/apps/wrap.gifts/src/app/home/HomePageModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2103436129/src/apps/wrap.gifts/src/app/home/SearchBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2103436129/src/apps/wrap.gifts/src/app/home/TemplateList.tsx");
